// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_warnings_errorfiles3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following attachments could not be analyzed due to an error:`)
};

const en_us2_assistantsalesorder_warnings_errorfiles3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following attachments could not be analyzed due to an error:`)
};

const de_de2_assistantsalesorder_warnings_errorfiles3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgende Anhänge konnten aufgrund eines Fehlers nicht analysiert werden:`)
};

const en_assistantsalesorder_warnings_errorfiles3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following attachments could not be analyzed due to an error:`)
};

const de_assistantsalesorder_warnings_errorfiles3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgende Anhänge konnten aufgrund eines Fehlers nicht analysiert werden:`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_warnings_errorfiles3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_warnings_errorfiles3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_warnings_errorfiles3", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_warnings_errorfiles3(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_warnings_errorfiles3(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_warnings_errorfiles3(inputs)
	if (locale === "en") return en_assistantsalesorder_warnings_errorfiles3(inputs)
	return de_assistantsalesorder_warnings_errorfiles3(inputs)
};
export { assistantsalesorder_warnings_errorfiles3 as "assistantSalesOrder.warnings.errorFiles" }